import { logger } from '@pkg/logger';
import imageUrlBuilder from '@sanity/image-url';
import type { SanityImageSource } from '@sanity/image-url/lib/types/types';

/**
 * Shared by apps/web + apps/business (via layers/base).
 * Modular blocks / UI image helpers expect `$urlFor` from Nuxt app context.
 */
export default defineNuxtPlugin({
  name: 'sanity-url-for',
  parallel: true,
  setup() {
    const sanity = useSanity();

    if (sanity.config.dataset == null) {
      logger.error('Sanity dataset is not defined - cannot provide sanity imageUrlBuilder, urlFor');
      return;
    }

    if (sanity.config.projectId == null) {
      logger.error('Sanity projectId is not defined - cannot provide sanity imageUrlBuilder, urlFor');
      return;
    }

    const builder = imageUrlBuilder({
      dataset: sanity.config.dataset,
      projectId: sanity.config.projectId,
    });

    function urlFor(source: SanityImageSource) {
      return builder.image(source);
    }

    return {
      provide: { urlFor },
    };
  },
});
